import './index.css';

import CustomSelect from "../CustomSelect";
import { chevronLeftIcon, chevronRightIcon } from "../../assets";
import { observer } from "mobx-react";
import CallStore from '../../stores/CallStore';

const Pagination = ({ pagination, getCalls }) => {
  // setQuery(pagination.page, pagination.limit);
  const { page, total, pages, limit } = pagination;

  const setValue = (value) => {
    if (value * page > total) {
      CallStore.setFilters({ page: (total / value) + 1, limit: value })
      getCalls();
    } else if (limit * page == total) {
      CallStore.setFilters({ page: (total / value), limit: value })
      getCalls();
    } else {
      CallStore.setFilters({ page: page, limit: value })
      getCalls();
    }
  }

  const goPreviousPage = () => {
    if (page > 1) {
      CallStore.setFilters({ page: page - 1, limit: limit })
      getCalls();
    }
  }

  const goNextPage = () => {
    if (page < pages) {
      CallStore.setFilters({ page: page + 1, limit: limit })
      getCalls();
    }
  }

  const setPage = (value) => {
    CallStore.setFilters({ page: value, limit: limit })
    getCalls();
  }

  const getVisiblePages = () => {
    if (pages <= 10) {
      return Array.from({ length: pages }, (_, index) => index + 1);
    }

    let start = Math.max(1, page - 4);
    let end = Math.min(pages, start + 9);

    if (end - start < 9) {
      start = Math.max(1, end - 9);
    }

    const visiblePages = [];
    if (start > 1) {
      visiblePages.push(1);
      if (start > 2) visiblePages.push('...');
    }

    for (let i = start; i <= end; i++) {
      visiblePages.push(i);
    }

    if (end < pages) {
      if (end < pages - 1) visiblePages.push('...');
      visiblePages.push(pages);
    }

    return visiblePages;
  }

  const limitList = [
    {
      key: 10,
      name: 10
    },
    {
      key: 20,
      name: 20
    },
    {
      key: 50,
      name: 50
    }
  ]

  return <div className="session-logs-view-pagination">
    <div className="session-logs-view-pagination-left">
      <span>Showing</span>
      <CustomSelect list={limitList} value={limit} setValue={setValue} />
      <span> of {total}</span>
    </div>
    <div className="session-logs-view-pagination-right">
      <button className="button-text-cta button-text-cta-small" onClick={goPreviousPage}
        style={page === 1 ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      >
        <img src={chevronLeftIcon} alt="chevron-left" />
      </button>
      <div className="session-logs-view-pagination-right-pages">
        {getVisiblePages().map((item, index) => (
          item === '...' ?
            <span key={`ellipsis-${index}`}>...</span> :
            <button
              className={`button-text-cta button-text-cta-small ${page === item ? 'session-logs-view-pagination-right-pages-active-page' : ''}`}
              key={item}
              onClick={() => setPage(item)}
              disabled={page === item}
            >
              <span>{item}</span>
            </button>
        ))}
      </div>
      <button className="button-text-cta button-text-cta-small" onClick={goNextPage}
        style={page === pages ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      >
        <img src={chevronRightIcon} alt="chevron-right" />
      </button>
    </div>
  </div>
}

export default observer(Pagination);